import React, { useEffect, useRef } from 'react';
import './ParallaxSection.css';

const ParallaxSection = () => {
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      
      const scrollPosition = window.scrollY;
      const sectionPosition = sectionRef.current.offsetTop;
      const distance = scrollPosition - sectionPosition;
      
      // Only apply parallax effect when the section is in view
      if (distance > -window.innerHeight && distance < window.innerHeight) {
        const parallaxOffset = distance * 0.4;
        sectionRef.current.style.backgroundPositionY = `calc(50% + ${parallaxOffset}px)`;
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <section className="parallax-section" ref={sectionRef}>
      <div className="parallax-overlay"></div>
      <div className="parallax-content">
        <blockquote className="parallax-quote">
          "Krásne pózy tela sú jedným z klúčov ku krásnym pózam mysle."
        </blockquote>
      </div>
    </section>
  );
};

export default ParallaxSection; 